import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ActivityScheduleService } from '../activity-schedule.service';
import { ActivitySchedule } from '../activity-schedule';
import { ActivityScheduleComponent } from '../activity-schedule/activity-schedule.component';
import * as moment from 'moment';

@Component({
    selector: 'app-activity-schedule-list',
    templateUrl: './activity-schedule-list.component.html',
    styleUrls: ['./activity-schedule-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ActivityScheduleListComponent implements OnInit {
	constructor(
		private activityScheduleService: ActivityScheduleService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = activityScheduleService.statuses
	}



	// data
	@Input() activityFeeId: any;
	@Input() showFilter = true;
	@Input() showPagination = true;
	activitySchedules: any;
	activitySchedule: ActivitySchedule;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'activityScheduleId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		// { field: 'description', header: 'Description', width: 'auto' },
		{ field: 'startTime', header: 'Start Time', width: 'auto' },
		{ field: 'endTime', header: 'End Time', width: 'auto' },
		{ field: 'duration', header: 'Duration', width: 'auto' },
		{ field: 'season', header: 'Season', width: 'auto' },
		{ field: 'activityFeeId', header: 'ActivityFeeId', width: 'auto' },
	];


	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.activityScheduleId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-activitySchedule-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			if(this.activityFeeId)
			{
				// show only activities that are assigned to this activityFeeId
				let activityFeeIdFilter = { 'activityFeeVO.activityFeeId': { 'value': this.activityFeeId, 'matchMode': 'in' } };
				Object.assign(event.filters, activityFeeIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.activityScheduleService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.activitySchedules = res.data.activitySchedules;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.activitySchedules = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(activitySchedule: ActivitySchedule) {
		try {
			this.formLoading = true;
			this.activityScheduleService.update(activitySchedule)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.activitySchedules.map((activitySchedule, i) => {
							if (activitySchedule.activityScheduleId === res.data.activitySchedule.activityScheduleId) {
								this.activitySchedules[i] = res.data.activitySchedule;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(activitySchedule: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(activitySchedule));

			this.formLoading = true;
			this.activityScheduleService.delete(activitySchedule.activityScheduleId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.activitySchedules.splice(this.activitySchedules.indexOf(activitySchedule), 1);
						this.recordTotal = this.activitySchedules.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ActivitySchedule ' + activitySchedule.activityScheduleId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'ActivitySchedule ' + activitySchedule.activityScheduleId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "80vw";
			dialogConfig.width = "60vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add ActivitySchedule',
			activityFeeId: this.activityFeeId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ActivityScheduleComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addActivityScheduleCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(activitySchedule: ActivitySchedule) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "80vw";
			dialogConfig.width = "60vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			activitySchedule: activitySchedule,
			activityFeeId: this.activityFeeId,
			title: 'Edit ActivitySchedule'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ActivityScheduleComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateActivityScheduleCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteActivityScheduleCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addActivityScheduleCB(activitySchedule: ActivitySchedule) {
		console.log('Adding ActivitySchedule: ' + JSON.stringify(activitySchedule));
		// if we don't have a activitySchedules array yet...
		if (!this.activitySchedules) {
			this.activitySchedules = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.activitySchedules.unshift(activitySchedule);

		// no idea what this is but it is required to update the array
		this.activitySchedules = [...this.activitySchedules];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ActivitySchedule ' + activitySchedule.activityScheduleId + ' Added', life: 3000 });
	}

	updateActivityScheduleCB(activitySchedule: ActivitySchedule) {
		console.log('Updating ActivitySchedule: ' + JSON.stringify(activitySchedule));
		let itemIndex = this.activitySchedules.findIndex((item: any) => item.activityScheduleId === activitySchedule.activityScheduleId);
		this.activitySchedules[itemIndex] = activitySchedule;

		// no idea what this is but it is required to update the array
		this.activitySchedules = [...this.activitySchedules];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ActivitySchedule ' + activitySchedule.activityScheduleId + ' Updated', life: 3000 });
	}

	deleteActivityScheduleCB(activitySchedule: ActivitySchedule) {
		console.log('Removing ActivitySchedule: ' + activitySchedule);
		this.activitySchedules.splice(this.activitySchedules.indexOf(activitySchedule), 1);
		this.recordTotal = this.activitySchedules.length;

		// no idea what this is but it is required to update the array
		this.activitySchedules = [...this.activitySchedules];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ActivitySchedule ' + activitySchedule.activityScheduleId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.activitySchedules ? this.first === (this.activitySchedules.length - this.rows) : true; }
	isFirstPage(): boolean { return this.activitySchedules ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(activitySchedule: any) {
		if (activitySchedule?.status) {
			const status = this.statuses.find((e: any) => e.value == activitySchedule.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}

	getTime(dateTime: any) {
		return moment(dateTime).format("HH:mm A");
	}
}
